import React from 'react';
import {observer} from 'mobx-react';
import {Box} from '@mui/material';
import CompletionProgressBar from '../../../components/CompletionProgressBar';
import FormSkeleton from '../../../components/FormSkeleton';
import useFeature from '../../../useFeature';
import {useApplication} from "../../../ApplicationProvider";
import FormFileField from "../../../components/fileUploadComponents/FormFileField";
import FormSection from "../../../forms/FormSection";
import FormTextField from "../../../components/fields/FormTextField";
import Typography from "@mui/material/Typography";


function FinanceDataPanel({generalFeature}) {
    const application = useApplication();
    const feature = useFeature(() => generalFeature.features['FinanceDataPanelFeature'])

    const isFeatureReady = (feature) => {
        return feature && feature.loaded;
    }

    if (!isFeatureReady(feature)) {
        return (
            <FormSkeleton
                rows={2}
                fieldsPerRow={2}
            />
        );
    }

    const form = feature.form;
    const paymentTerm = feature.paymentTermCode()
    return (
        <Box p={3} display="flex" flexDirection="column" gap={3}>
            <CompletionProgressBar form={form} />
            <FormSection title="Cuenta Corriente">
                {paymentTerm && <Typography style={{ fontSize: "14px" }}>Condición de pago: {paymentTerm}</Typography>}
                <Box sx={{ width: "20%" }}>
                        <FormFileField
                            title="Documento de Nosis"
                            form={form}
                            fieldName="nosisDocument"
                            placeholder="Subir archivo..."
                            singleFile
                        />
                    </Box>
            </FormSection>
            <FormSection title="Comentarios">
                    <FormTextField
                        fullWidth
                        multiline
                        minRows={4}
                        placeholder="Escriba sus Observaciones aquí..."
                        form={form}
                        fieldName={"financeObservations"}
                    />
            </FormSection>
        </Box>
    );
}

export default observer(FinanceDataPanel);
